

































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { AuthorisedOnly } from "@/lib/decorators";
import { getElement } from "@/lib/elementHelpers";
import { $t } from "@/lib/i18nHelpers";
import { AttachmentFile } from "@/types";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseSpinner from "@/components/BaseSpinner";

@Component({ name: "BaseSendMessage", components: { BaseInputTextarea, BaseSpinner } })
export default class BaseSendMessage extends Vue {
  @Prop({ type: Boolean, default: false })
  public readonly keepFocus!: boolean;

  @Prop({ required: true })
  public readonly sending!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly transparent!: boolean;

  @Prop({ default: null })
  public readonly files!: AttachmentFile[] | null;

  @Prop({ default: $t("Message") })
  public readonly placeholder!: string;

  @Prop({ type: String })
  public readonly priceAmount!: string | undefined;

  @Prop({ type: String, default: "" })
  public readonly userId!: string;

  @Prop({ default: "sci-send" })
  public readonly appendIcon!: string;

  @Prop()
  public readonly prependIcon!: string;

  @Prop()
  public readonly secondPrependIcon!: string;

  @Prop({ type: String, default: "" })
  public readonly prependedText!: string;

  @Prop({
    type: Function,
    default: (value: string) => {
      return value.length > 0;
    },
  })
  public allowSend!: (value: string) => boolean;

  public value: string = "";

  @Watch("prependedText")
  public pastePrependedText(text: string) {
    this.value = text;
    this.$emit("input", this.value);
  }

  public clearInput() {
    this.value = "";
    this.$emit("input", this.value);
  }

  public inputMessage(v: string) {
    this.value = v;
    this.$emit("input", this.value);
  }

  @AuthorisedOnly(ctx => ctx.userId)
  public sendMessage() {
    if (this.sending || !this.allowSend(this.value) || (!this.value && !this.files)) return;
    this.$emit("send", this.value, this.clearInput);
    if (this.keepFocus) {
      try {
        getElement<HTMLInputElement>((this.$refs.baseInput as Vue).$refs.textarea).focus();
      } catch (e) {}
    }
  }
}
